import React__default, { createContext, useContext } from "react";
let e = createContext(false);
function a() {
  return useContext(e);
}
function l(o) {
  return React__default.createElement(e.Provider, { value: o.force }, o.children);
}
export {
  l as ForcePortalRoot,
  a as usePortalRoot
};
